<template>
  <h2 class="side-menu-header">
    <a class="unit-arrow" id="left-arrow" @click="unitLeftMove()">
      <img src="../assets/images/arrow_left_light.png" class="left-arrow-img img-mode" alt=" " />
    </a>
    <p id="side-menu-header-txt" v-html="currentUnit"></p>
    <a class="unit-arrow" id="right-arrow" @click="unitRightMove()">
      <img src="../assets/images/arrow_right_light.png" class="right-arrow-img img-mode" alt=" " />
    </a>
  </h2>
</template>

<script>
import { inject } from "vue";
import { onMounted } from "vue";
import { useStore } from "vuex";
// import { useRoute } from "vue-router";
import UnitTitlesJson from "@/assets/json/unit_titles.json";

export default {
  name: "SideMenuHeader",
  methods: {
    unitLeftMove() {
      //矢印パス設定
      // console.log("left");
      for(let i = 0;i < UnitTitlesJson.unit_titles.length;i++){
        if((UnitTitlesJson.unit_titles[i].link_name === location.pathname.slice(-1-UnitTitlesJson.unit_titles[i].link_name.length, -1 )) || (UnitTitlesJson.unit_titles[i].link_name === location.pathname.slice(-UnitTitlesJson.unit_titles[i].link_name.length))){
          // console.log(UnitTitlesJson.unit_titles[i].link_name)
          // if(i === 0){
          //   rightArrowPath = "../"+UnitTitlesJson.unit_titles[i+1].link_name;
          // }else if(i === UnitTitlesJson.unit_titles.length-1){
          //   this.$router.push("../"+UnitTitlesJson.unit_titles[i-1].link_name);
          // }else{
          //   rightArrowPath = "../"+UnitTitlesJson.unit_titles[i+1].link_name;
            this.$router.push("/"+UnitTitlesJson.unit_titles[i-1].link_name+"/");
          }
        }
      },
    unitRightMove() {
      //矢印パス設定
      // console.log("right");
      for(let i = 0;i < UnitTitlesJson.unit_titles.length;i++){
        if((UnitTitlesJson.unit_titles[i].link_name === location.pathname.slice(-1-UnitTitlesJson.unit_titles[i].link_name.length, -1 )) || (UnitTitlesJson.unit_titles[i].link_name === location.pathname.slice(-UnitTitlesJson.unit_titles[i].link_name.length))){
          // console.log(UnitTitlesJson.unit_titles[i].link_name)
          // if(i === 0){
          //   this.$router.push("../"+UnitTitlesJson.unit_titles[i+1].link_name);
          // }else if(i === UnitTitlesJson.unit_titles.length-1){
          //   leftArrowPath = "../"+UnitTitlesJson.unit_titles[i-1].link_name;
          // }else{
            this.$router.push("/"+UnitTitlesJson.unit_titles[i+1].link_name+"/");
            // leftArrowPath = "../"+UnitTitlesJson.unit_titles[i-1].link_name;
          // }
        }
      }
    },
  },
  setup() {
    const currentUnit = inject("currentUnit");
    const store = useStore();
    const imgClass = document.getElementsByClassName("img-mode");
    // let leftArrowPath = "../";
    // let rightArrowPath = "../";
    let lightImg = [
      require("../assets/images/arrow_left_light.png"),
      require("../assets/images/arrow_right_light.png"),
    ];
    let darkImg = [
      require("../assets/images/arrow_left_dark.png"),
      require("../assets/images/arrow_right_dark.png"),
    ];
    
    onMounted(() => {
      changeImg();
      //矢印表示出し分け
      const rightArrow = document.getElementById("right-arrow")
      const leftArrow = document.getElementById("left-arrow")
      for(let i = 0;i < UnitTitlesJson.unit_titles.length;i++){
        if((UnitTitlesJson.unit_titles[i].link_name === location.pathname.slice(-1-UnitTitlesJson.unit_titles[i].link_name.length, -1 )) || (UnitTitlesJson.unit_titles[i].link_name === location.pathname.slice(-UnitTitlesJson.unit_titles[i].link_name.length))){
          rightArrow.style.display = "block"
          leftArrow.style.display = "block"
          if(i === 0){
            leftArrow.style.display = "none"
          }else if(i === UnitTitlesJson.unit_titles.length-1){
            rightArrow.style.display = "none"
          }
          // console.log(location.pathname.slice(-1-UnitTitlesJson.unit_titles[i].link_name.length, -1 ))
          // console.log(location.pathname.slice(-UnitTitlesJson.unit_titles[i].link_name.length))
        }
      }
      //単元が一つなら非表示,もしくはunitArrowFragをfalseにしていれば非表示
      if((UnitTitlesJson.unit_titles.length === 1)||(!UnitTitlesJson.unitArrowFrag)){
        leftArrow.style.display = "none"
        rightArrow.style.display = "none"
      }
    });
    
    store.subscribe((mutation) => {
      if (mutation.type === 'toggleDarkMode') {
        //ダークモード切り替わり検知、表示切替
        changeImg();
      }
    })

    //ダークモード画像切り替え
    const changeImg = () => {
      if (store.state.isDarkMode == true) {
        //ダークモードオフ
        for (let i = 0; i < imgClass.length; i++) {
          imgClass[i].setAttribute('src', darkImg[i]);
        }
      } else if (store.state.isDarkMode == false) {
        //ダークモードオン
        for (let i = 0; i < imgClass.length; i++) {
          imgClass[i].setAttribute('src', lightImg[i]);
        }
      }
    }
    return {
      currentUnit,
      // leftArrowPath,
      // rightArrowPath,
    };
  },
};
</script>

<style scoped lang="stylus">
h2
  color var(--light-black)
  font-size 16px
  text-align center
  padding 30px 30px
  background-color var(--light-yellow)
  transition all .5s ease-out;
.dark-mode
  h2
    color var(--dark-white)
    background-color var(--dark-deepblue-dark)
    transition all .5s ease-out;
.side-menu-header
  display:flex
  justify-content: center;


.unit-arrow
  cursor pointer

.left-arrow-img
  position absolute
  width:15px
  left 0%
  margin-right:5px
  margin-left:16px

.right-arrow-img
  position absolute
  width:15px
  right 0%
  margin-right:16px
  margin-left:5px
  
</style>
